import Loadable from 'react-loadable';

import { LoadingPage } from 'src/components/react-loadable';

export const DetectionSettingsLoadable = Loadable<any, never>({
  loading: LoadingPage,
  loader: () =>
    import('./detection-settings').then(m => m.DetectionSettingsPage),
});
